import React, { useState, useEffect } from 'react';
import snakeCaseKeys from 'snakecase-keys';
import { Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import BenefitForm from './BenefitForm';
import { sendAlert } from '../../actions/utils';
import { showBenefitsRequest, updateBenefitsRequest } from '../../requests/benefits';
import { camelCaseEmptyStringRecursive } from '../../services/utils';
import defaultBenefit from './benefit';

const BenefitEdit = ({ moreData, setMoreData }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const [benefit, setBenefit] = useState(defaultBenefit);
  const [onRequest, setOnRequest] = useState(true);

  const handleUpdateRequest = (benefitValues, setSubmitting) => {
    const { benefitsImage, attachedFile } = benefitValues.benefit;
    const myParams = snakeCaseKeys(benefitValues);
    myParams.benefit.image = benefitsImage;
    myParams.benefit.attached_file = attachedFile;

    updateBenefitsRequest(id, {
      dispatch,
      params: myParams,
      formData: true,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Beneficio actualizado con éxito' }));
        history.push('/benefits');
      },
      failureCallback: error => {
        setSubmitting(false);
        const { response } = error;
        dispatch(sendAlert({ kind: 'error', message: response?.data?.message }));
      },
      callback: () => setMoreData?.(!moreData)
    });
  };

  const handleShowRequest = () => {
    setOnRequest(true);
    showBenefitsRequest(id, {
      dispatch,
      successCallback: res => {
        setBenefit(camelCaseEmptyStringRecursive(res.data));
        setOnRequest(false);
      }
    });
  };

  useEffect(handleShowRequest, []);

  return (
    <>
      {onRequest && <Spinner className="spinner-modal fix-spinner" animation="border" variant="primary" />}
      <div className={`${onRequest && 'bg-opacity'}`}>
        <BenefitForm benefit={benefit} action="edit" formRequest={handleUpdateRequest} />
      </div>
    </>
  );
};

export default BenefitEdit;
